import { Component, OnInit } from '@angular/core';
import { Product } from '../../../../classes/Product';
import { ImagesService } from '../../../services/images.service';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import { AlertsService } from '../../../services/alerts.service';
import { DomSanitizer } from '@angular/platform-browser';
import * as $ from 'jquery';

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.css']
})
export class AddProductComponent implements OnInit {

  cropperInited: boolean = false;
  isSubmitButtonDisabled: boolean = false;
  newProduct: Product = new Product( );

  manufacturers = [];
  
  availableRoles: string[] = [ 'admin', 'sales', 'manager' ];
  isAvailable: boolean = true;


  linkedProduct: any = {};
  linkedProductPopupVisible: boolean = false;

  specsName: string = '';
  
  addLinkedProductButtonDisabled: boolean = false;

  // Lists for overlay
  productTypesList  = [];
  baseTypesList     = [];
  descriptionsList  = [];

  isProductFieldDisabled: boolean = true;

  // Control for overlay additional fields
  showAdditionalFields: boolean = false;

  // Filters for overlay
  filters: any = {
    available_entity: '',
    need_proposed: false,
    type:         '',
    entity:       '',
    productType:  '',
    baseType:     '',
    description:  '',
    excludeID:    []
  };

  productList: any[] = [];

  _productTypes: any[] = [];
  _baseTypes: any[] = [];

  _addNewProductType: boolean = false;
  _addNewBaseType: boolean = false;

  _newProductType: string = '';
  _newBaseType: string = '';

  // Additional info on overlay
  additionalOverlayFields = { }

  popupMinimized: boolean = false;


  SKUSearch: string = '';
  descriptionSearch: string = '';
  searchBySKU: boolean = true;


  selectParams: any = {

    existingOrProposed: {
      id: 'inputExistingOrProposed',
      isDisabled: this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager',
      isRequired: true,
      change: ( event ) => { 
        this.newProduct.existingOrProposed = event.value; 
        this.changeType( );
      },
      options: [ { text: '', value: '' } ]
    },

    manufacturer: {
      id: 'inputManufacturer',
      isRequired: this.newProduct.existingOrProposed == 'proposed',
      change: ( event ) => { 
        this.newProduct.manufacturer_id = event.value;
        this.changeManufacturerSelect( );
      },
      options: [ { text: '', value: '' } ]
    },

    productType: {
      id: 'selectProductType',
      isDisabled: !this._productTypes.length || !this.newProduct.manufacturer_id,
      isRequired: true,
      change: ( event ) => { 
        this.newProduct.productType = event.value; 
        this.newProduct.baseType = ''; 
        this.changeProductTypeSelect( );
      },
      options: [ { text: '', value: '' } ]
    },

    baseType: {
      id: 'selectBaseType',
      isDisabled: !this._baseTypes.length || !this.newProduct.manufacturer_id || !this.newProduct.productType,
      isRequired: true,
      change: ( event ) => { this.newProduct.baseType = event.value; },
      options: [ { text: '', value: '' } ]
    },


    overlayEntity: {
      id: 'inputLinkedProductProductType',
      isRequired: true,
      change: ( event ) => {
        this.linkedProduct.entity = event.value;
        this.changeLinkedProductProperty( 'entity', '' );
      },
      options: [ 
      { text: '', value: '' },
      { text: 'Lamp', value: 'bulb' },
      { text: 'Fixture', value: 'fixture' },
      { text: 'Accessory', value: 'accessory' },
      { text: 'Housing', value: 'housing' },
      ],
      search: false
    },


    overlayProductType: {
      id: 'inputLinkedProductProductType',
      isRequired: true,
      isDisabled: this.isProductFieldDisabled,
      change: ( event ) => {
        this.filters.productType = event.value;
        this.changeLinkedProductProperty( 'productType', event.value );
      },
      options: [ { text: '', value: '' } ]
    },


    overlayBaseType: {
      id: 'inputLinkedProductBaseType',
      isDisabled: this.isProductFieldDisabled,
      isRequired: true,
      change: ( event ) => {
        this.filters.baseType = event.value;
        this.changeLinkedProductProperty( 'baseType', event.value );
      },
      options: [ { text: '', value: '' } ]
    },


    overlayDescription: {
      id: 'inputLinkedProductDescription',
      isRequired: true,
      isDisabled: this.isProductFieldDisabled,
      change: ( event ) => {
        this.filters.description = event.value;
        this.setNewLinkedProductEntityID(  event.value );
        this.changeLinkedProductProperty( 'description', event.value );
      },
      options: [ { text: '', value: '' } ]
    }

  }


  constructor ( 
    private model: ModelService,
    private cropper: ImagesService,
    public global: GlobalService,
    private alerts: AlertsService,
    private sanitizer: DomSanitizer,
    private loginService: LoginService ) { 
    this.global.setDocumentTitle( 'Add Product' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;


    // this.selectParams.existingOrProposed.options.push( { text: 'Existing', value: 'existing', disabled: this.newProduct.entity!='accessory' && this.newProduct.entity!='housing' } );
    this.selectParams.existingOrProposed.options.push( { text: 'Existing', value: 'existing' } );
    if ( this.loginService.userInfo.role != 'sales' && this.loginService.userInfo.role != 'manager' ) this.selectParams.existingOrProposed.options.push( { text: 'Proposed', value: 'proposed' } );

    this.newProduct.existingOrProposed = 'proposed'; 
    this.changeType( );
  }

  ngOnInit ( ) { 

    // Set default entity is bulb and type to existing
    this.newProduct.entity = 'fixture';
    if ( this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager' ) {
      this.newProduct.existingOrProposed = 'existing';
      this.newProduct.sellPrice        = 0;
      this.newProduct.buyPrice         = 0;
      this.newProduct.markup           = 0;
    }

    this.getManufacturersData( );
  }
  
  minimizePopup ( ) { 
    this.popupMinimized = !this.popupMinimized; 
    this.fixingBodyOverflow( );
  }

  changeSpecs ( $event ) {

    let file: any = $event.target.files[0];

    if ( !file ) return;

    this.global.showPreloader( );
    let formData = new FormData( );
    formData.append( 'pdf', file, file.fileName );
    this.model.uploadProductSpecs( formData, file.fileName, ( response ) => {
      this.newProduct.specsPDF = response.url;
      this.specsName = response.url.substring(response.url.lastIndexOf('/')+1);
      this.global.hidePreloader( );
    });
  }

  getManufacturersData ( ) {
    this.model.getManufacturersDataWithEntity( this.newProduct.entity, ( data ) => {
      this.global.hidePreloader( ).subscribe( );
      this.manufacturers = data;
      this.selectParams.manufacturer.options = [ { text: '', value: '' } ];
      data.forEach( _mn => {
        this.selectParams.manufacturer.options.push( { text: _mn.name, value: _mn.id } );
      });
    });
  }

  deleteImage ( inputFile, public_id ) {
    inputFile.value = '';
    this.cropper.destroyImage( public_id, ( ) => {
        this.newProduct.attachment = '';
        this.newProduct.attachment_public_id = '';
    });
  }

  changeType ( ) {
    if ( this.newProduct.existingOrProposed == 'existing' ) {
      this.newProduct.sellPrice        = 0;
      this.newProduct.buyPrice         = 0;
      this.newProduct.markup           = 0;
    } else if ( this.newProduct.existingOrProposed == 'proposed' ) {
      if ( this.newProduct.sellPrice == 0 ) delete this.newProduct.sellPrice;
      if ( this.newProduct.buyPrice == 0 ) delete this.newProduct.buyPrice;
      if ( this.newProduct.markup == 0 ) delete this.newProduct.markup;
    }
    this.selectParams.manufacturer.isRequired = this.newProduct.existingOrProposed == 'proposed';
  }

  changeManufacturerSelect ( ) { 
    this.changeProductMarkup( ( ) => {
      this.getProductsTypes( );
    });
  }

  changeProductTypeCheckbox ( ) {
    if ( this._addNewProductType ) this._addNewBaseType = true;
    this.getBaseType( );
  }

  changeProductTypeSelect ( ) {
    this.getBaseType( ( ) => {
      if ( this.newProduct.productType && this._baseTypes.length ) this._addNewBaseType = false;
    });
  }

  getBaseType ( cb? ) {
    this.model.getBaseTypeData( this.newProduct.manufacturer_id, this.newProduct.productType, this.newProduct.entity, ( baseTypes ) => {
      this._baseTypes = baseTypes;
      this.selectParams.baseType.options = [ { text: '', value: '' } ];
      baseTypes.forEach( _bt => {
        this.selectParams.baseType.options.push( {text: _bt, value: _bt} );
      });
      if ( !baseTypes.length ) this._addNewBaseType = true;
      if ( cb ) cb( )
    });
  }

  getProductsTypes ( ) {
    this.model.getProductsTypeData( this.newProduct.manufacturer_id, this.newProduct.entity, ( productTypes ) => {
      this._productTypes = productTypes;
      this.selectParams.productType.options = [ { text: '', value: '' } ];
      if ( !productTypes.length ) {
        this._addNewProductType = true;
        this._addNewBaseType = true;
      } else {
        productTypes.forEach( _pt => {
          this.selectParams.productType.options.push( { text: _pt, value: _pt } );
        });
        this._addNewProductType = false;
        this._addNewBaseType = false;
      }
    });
  }

  changeProductMarkup ( cb? ) { 
    if ( !this.newProduct.manufacturer_id ) return;
    this.model.getManufacturerDataByID ( this.newProduct.manufacturer_id, ( manufacturer ) => {
      this.newProduct.markup = manufacturer.markup; 
      this.calculateSellPrice( );
      if ( cb ) cb( )
    });
  }

  calculateSellPrice ( ) {
    if ( this.newProduct.buyPrice ) {
      if ( this.newProduct.markup ) {
        this.newProduct.sellPrice = ( +this.newProduct.buyPrice + ( this.newProduct.buyPrice * this.newProduct.markup / 100 ) ).toFixed( 2 ).toString( );
      } else {
        this.newProduct.sellPrice = +this.newProduct.buyPrice;
      }
    }
  }

  calculateBuyPrice ( ) {
    if ( this.newProduct.sellPrice ) {
      if ( this.newProduct.markup ) {
        // this.newProduct.sellPrice = +this.newProduct.buyPrice + ( this.newProduct.buyPrice * this.newProduct.markup / 100 );
        this.newProduct.buyPrice = ( ( +this.newProduct.sellPrice ) / ( 1 + this.newProduct.markup / 100 ) ).toFixed( 2 ).toString( );
      } else {
        this.newProduct.buyPrice = +this.newProduct.sellPrice;
      }
    }
  }

  calculateMarkup ( ) {
    if ( this.newProduct.sellPrice ) {
      if ( this.newProduct.buyPrice ) {
         this.newProduct.markup = ( 100 * ( ( +this.newProduct.sellPrice - +this.newProduct.buyPrice ) / +this.newProduct.buyPrice ) ).toFixed( 1 ).toString( );
      }
    }
  }

  calculateBothPrice ( ) {
    this.calculateSellPrice( );
    this.calculateBuyPrice( );
  }

  calculateTotalWatts ( ) {
    if ( this.newProduct.entity == 'housing' ) return;
    if ( this.newProduct.wattsPerLamp ) {
      if ( this.newProduct.lampsPerProduct ) {
        this.newProduct.watts = +this.newProduct.wattsPerLamp * +this.newProduct.lampsPerProduct;
      } else {
        this.newProduct.watts = +this.newProduct.wattsPerLamp;
      }
    } else {
        this.newProduct.watts = 0;
    }
  }

  successCallback ( ) {
    this.global.defaultSuccessMessage({ 
      html: 'New product has been added successfully', 
      redirect: '/products-list' 
    });
  }

  errorCallback ( message?: string ) {
    let data = {
      messageType: 'error',
      message: message || 'We got some error here...',
      title: ''
    }
    this.alerts.setData( data ).subscribe( );
    this.isSubmitButtonDisabled = false;
  }

  setProductType ( productType ) { 
    
    this.newProduct.entity = productType; 
    if ( productType == 'housing' || productType == 'accessory' ) this.newProduct.existingOrProposed = 'proposed';

    this.selectParams.existingOrProposed.options = [ 
      { text: '', value: '' },
    ];

    if ( this.newProduct.entity!='accessory' && this.newProduct.entity!='housing' ) this.selectParams.existingOrProposed.options.push({ text: 'Existing', value: 'existing' });
    if ( this.loginService.userInfo.role != 'sales' && this.loginService.userInfo.role != 'manager' ) this.selectParams.existingOrProposed.options.push( { text: 'Proposed', value: 'proposed' } );

    this.getManufacturersData( );
  }

  submitForm ( ) {

    this.isSubmitButtonDisabled = true;
    this.newProduct.basicSpec = $( '#inputBasicSpecs' ).html( );

    if ( this._addNewProductType ) this.newProduct.productType = this._newProductType;
    if ( this._addNewBaseType ) this.newProduct.baseType = this._newBaseType;

    if ( +this.newProduct.sellPrice < +this.newProduct.buyPrice ) {
      this.errorCallback( 'Sell price can not be less then buy price' );
      this.global.defaultErrorCallback( 'Sell price can not be less then buy price' );
      $( '#inputSellPrice' ).focus( );
      return false;
    }
    
    let _basicSpecs;
    _basicSpecs = $.trim( $( '#inputBasicSpecs' ).text( ) );

    if ( _basicSpecs == "" ) {
      this.global.defaultErrorCallback( 'Field "Basic specs" cannot be empty!', false );
      this.isSubmitButtonDisabled = false;
      return false;
    }

    if ( this.newProduct.entity == 'fixture' ) this.newProduct.baseType = 'N/A';

    this.model.addProduct( this.newProduct, ( response ) => {
      let _active = true;
      let _existsErrorMessage = 'This product already exists';
      let _answer = response.json( ).answer;
      
      if ( _answer == 'success' ) this.successCallback( );
      else {
        if ( _answer == 'exists' ) {
          _active = response.json( ).active;
          if ( _active ) {
            _existsErrorMessage = 'Product with this Product Type + Description already exists in the database: Active';
            if ( this.newProduct.existingOrProposed == 'proposed' ) _existsErrorMessage = 'Product with this Product Type + Description + Manufacturer already exists in the database: Active';
          } else {
            _existsErrorMessage = 'Product with this Product Type + Description already exists in the database: Inactive';
            if ( this.newProduct.existingOrProposed == 'proposed' ) _existsErrorMessage = 'Product with this Product Type + Description + Manufacturer already exists in the database: Inactive';
          }
          this.errorCallback( _existsErrorMessage );
          this.global.defaultErrorCallback( _existsErrorMessage );
        } else {
          this.errorCallback( _answer );
          this.global.defaultErrorCallback( _answer, false );
        }
      }
    });
    return false;
  }

  cancelSubmit ( ) {
    this.global.redirect( '/products-list' );
  }


  ///////////////////////////////////////
  ///////////////////////////////////////
  //             
  //             Overlay
  //             
  ///////////////////////////////////////
  ///////////////////////////////////////


  removeLinkedProduct ( ind:number ) {
    // this.newProduct.linkedProducts.splice( ind, 1 );

    let _answer;
    let data = {
      message: "Warning! Are you sure you want to remove this selection?",
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    };

    this.global.confirmMessage( data, ( ) => {
      this.newProduct.linkedProducts.splice( ind, 1 );
    });

  }

  showLinkedProductProductOverlay ( ) {

    this.linkedProduct = {};
    this.linkedProduct.type = 'proposed';

    this.linkedProductPopupVisible = true;
    this.fixingBodyOverflow( );
  }


  saveLinkedProduct ( ) {

    // Code to save it when we press "Save" on overlay
    
    this.newProduct.linkedProducts.push( this.linkedProduct );
    this.linkedProductPopupVisible = false;
    this.fixingBodyOverflow( );

  }

  getExcludeID ( entityID ) {

    let excludeID = [];

    this.newProduct.linkedProducts.forEach( ( product ) => {
      if ( excludeID.indexOf( product.entityID ) == -1 && product.entityID != entityID ) excludeID.push( product.entityID );
    });

    console.log( 'getExcludeID add product' );

    return excludeID;

  }

  addLinkedProduct ( ) {

    this.showAdditionalFields = false;
    this.isProductFieldDisabled = true;

    this.SKUSearch = '';
    this.descriptionSearch = '';
    this.searchBySKU = true;

    this.filters = {
      need_proposed: false,
      type:         'proposed',
      entity:       '',
      productType:  '',
      baseType:     '',
      description:  '',
      excludeID:    this.getExcludeID ( 0 )
    };

    this.getProductsDataExcluding( ( products, _filters ) => {
      this.filters.need_proposed = _filters.need_proposed;
      this.showLinkedProductProductOverlay ( );
    });

    return false;
  }


  changeLinkedProductProperty ( _type, _value, cb? ) {
    let _entity = this.linkedProduct.entity;
    let existInLinked = false;
    if ( _entity ) this.isProductFieldDisabled = false;
    else this.isProductFieldDisabled = true;
    this.filters.entity = _entity || '';

    if ( _type == 'search' ) {
      this.filters.search = _value;
      this.filters.searchDescription = '';
    }
    if ( _type == 'searchDescription' ) {
      this.filters.search = '';
      this.filters.searchDescription = _value;
      _type = 'search';
    }

    if ( _type == 'entity' ) {
      this.filters.productType  = '';
      this.filters.baseType     = '';
      this.filters.description  = '';
    }
    if ( _type == 'productType' ) {
      if ( _value && _entity == 'fixture' ) {
        this.filters.baseType = 'N/A';
        _type = 'baseType';
      } else {
        this.filters.baseType     = '';
        this.filters.description  = '';
      }
    }
    if ( _type == 'baseType' ) {
      this.filters.description  = '';
    }
    

    if ( _type != 'description' ) {
      this.model.getProductsDataExcluding( this.filters, _type, ( products, _filters ) => {

        if ( this.searchBySKU ) { 
          if ( _filters.description.length ) {


            this.newProduct.linkedProducts.forEach( ( product ) => {
              if ( product.entityID == _filters.description[0].id ) existInLinked = true;
            });


            if ( existInLinked ) {
              this.global.defaultErrorCallback( 'Product you are trying to link is already linked.' );
              return;
            }

            this.filters.description = _filters.description[0].id;
            this.filters.entity = _filters.description[0].entity;
            this.filters.productType = _filters.description[0].productType;
            this.filters.baseType = _filters.description[0].baseType;
            this.linkedProduct.entity = _filters.description[0].entity;
            this.linkedProduct.productType = _filters.description[0].productType;
            this.linkedProduct.baseType = _filters.description[0].baseType;
            this.productTypesList = [ _filters.description[0].productType ];
            this.baseTypesList = [ _filters.description[0].baseType ];
            this.descriptionsList = _filters.description;
            this.prepareProductTypeList( );
            this.prepareBaseTypeList( );
            this.prepareDescriptionsList( );
            this.setNewLinkedProductEntityID(  _filters.description[0].id );
            this.changeLinkedProductProperty( 'description', _filters.description[0].id, true );
          } else {
            this.filters.entity = '';
            this.filters.productType = '';
            this.filters.baseType = '';
            this.filters.description = '';
            this.linkedProduct.entity = '';
            this.linkedProduct.productType = '';
            this.linkedProduct.baseType = '';
            this.productTypesList = [ ];
            this.baseTypesList = [ ];
            this.descriptionsList = [ ];
            this.prepareProductTypeList( );
            this.prepareBaseTypeList( );
            this.prepareDescriptionsList( );
            this.changeLinkedProductProperty( 'description', '', true );
            this.setNewLinkedProductEntityID(  '' );
            if (this.SKUSearch) {
              this.global.defaultErrorCallback( 'Product with SKU "'+this.SKUSearch+'" is not available' );
            }
            if (this.descriptionSearch) {
              this.global.defaultErrorCallback( 'Product with description "'+this.descriptionSearch+'" is not available' );
            }
          }
          return;
        }

        this.productList = products;
        this.productTypesList = _filters.productType;
        this.baseTypesList = _filters.baseType;
        this.descriptionsList = _filters.description;
        this.prepareProductTypeList( );
        this.prepareBaseTypeList( );
        this.prepareDescriptionsList( );

        if ( this.global.isFunction( cb ) ) cb( );
      }, 'linkedProduct');
    }
  }

  fillLinkedProductAdditionalInfo ( product ) {

    this.showAdditionalFields = true;
    this.additionalOverlayFields = {};
    this.additionalOverlayFields['description'] = product.description;
    this.additionalOverlayFields['SKU'] = product.SKU;
    this.additionalOverlayFields['entity'] = product.entity;
    this.additionalOverlayFields['attachment'] = product.attachment;
    this.additionalOverlayFields['sellPrice'] = '$'+product.sellPrice;

    if ( product.entity == 'fixture' || product.entity == 'bulb' ) {
      this.additionalOverlayFields['watts'] = product.watts;
      this.additionalOverlayFields['life'] = product.life;
    }

    if ( product.entity == 'fixture' ) {
      this.additionalOverlayFields['wattsPerLamp'] = product.wattsPerLamp;
      this.additionalOverlayFields['lampsPerProduct'] = product.lampsPerProduct;
    }

    if ( product.entity == 'housing' ) {
      this.additionalOverlayFields['lampsPerProduct'] = product.lampsPerProduct;
    }

    this.additionalOverlayFields['manufacturer'] = product.manufacturer_name;
  }


  setNewLinkedProductEntityID ( entityID ) {
    this.linkedProduct.entityID = entityID;
    if ( entityID == '' ) return;
    this.model.getProductDataByID( entityID, ( product ) => {
      this.linkedProduct.description = product.description;
      this.linkedProduct.manufacturer = product.manufacturer_name;
      this.linkedProduct.productType = product.productType;
      this.linkedProduct.baseType = product.baseType;
      this.linkedProduct.SKU = product.SKU;


      if ( product.specsPDF ) this.linkedProduct['specsPDF'] = product.specsPDF;
      else this.linkedProduct['specsPDF'] = '';
      if ( product.video ) this.linkedProduct['video'] = this.sanitizer.bypassSecurityTrustResourceUrl( product.video.toString( ).replace( 'watch?v=', 'embed/' ) );
      else this.linkedProduct['video'] = '';

      this.fillLinkedProductAdditionalInfo( product );
    });
  }

  getProductsDataExcluding ( cb ) {
    
    this.model.getProductsDataExcluding( this.filters, '', ( products, _filters ) => {
      this.productList = products;
      this.productTypesList = _filters.productType;
      this.baseTypesList = _filters.baseType;
      this.descriptionsList = _filters.description;
      this.prepareProductTypeList( );
      this.prepareBaseTypeList( );
      this.prepareDescriptionsList( );
      cb( products, _filters );
    }, 'linkedProduct' );
  }

  cancelNewLinkedProduct ( ) {
    this.linkedProductPopupVisible = false;
    this.fixingBodyOverflow( );
  }


  prepareProductTypeList ( ) {

    this.selectParams.overlayProductType.options = [{ value: '', text: '' }];

    this.productTypesList.forEach( _pt => {
      this.selectParams.overlayProductType.options.push( { value: _pt, text: _pt } );
    });
  }

  prepareBaseTypeList ( ) {
    
    this.selectParams.overlayBaseType.options = [{ value: '', text: '' }];

    this.baseTypesList.forEach( _bt => {
      this.selectParams.overlayBaseType.options.push( { value: _bt, text: _bt } );
    });
  }

  prepareDescriptionsList ( ) {

    let _SKU = '';

    this.selectParams.overlayDescription.options = [{ value: '', text: '' }];
    this.descriptionsList.forEach( _ds => {
      _SKU = _ds.SKU || 'N/A';
      this.selectParams.overlayDescription.options.push( { value: _ds.id, text: '$'+_ds.sellPrice+' — '+_ds.manufacturer+' — '+_ds.description , title: _SKU} );
    });
  }


  fixingBodyOverflow ( ) { this.global.fixBodyOverflow( this.linkedProductPopupVisible == true && this.popupMinimized == false ); }

  searchSKU ( $event ) {

    this.SKUSearch = $event.value;
    this.changeLinkedProductProperty( 'search', this.SKUSearch );

  }
  searchDescription ( $event ) {

    this.descriptionSearch = $event.value;
    this.changeLinkedProductProperty( 'searchDescription', this.descriptionSearch );

  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/products/add-product/add-product.component.ts